import { QuestionPlanPreQuestions as Question } from "@/components/features/items/edit/plan/_shared/ui/components/pre-questions/pre-questions";

import { useDayTripPlanI18nPreQuestions } from "./hooks/use-day-trip-pre-questions";

export const QuestionDayTripPlanI18nPreQuestions = () => {
	const {
		appendQuestion,
		removeQuestion,
		reorderQuestions,
		questions,
		onSetIsRequired,
		onSetQuestionType,
		onSetTitle,
		appendOptionItem,
		removeOptionItem,
		onSetOptionItem,
	} = useDayTripPlanI18nPreQuestions();

	return (
		<Question
			questions={questions}
			appendQuestion={appendQuestion}
			removeQuestion={removeQuestion}
			reorderQuestions={reorderQuestions}
			onSetIsRequired={onSetIsRequired}
			onSetQuestionType={onSetQuestionType}
			onSetTitle={onSetTitle}
			appendOptionItem={appendOptionItem}
			removeOptionItem={removeOptionItem}
			onSetOptionItem={onSetOptionItem}
		/>
	);
};

QuestionDayTripPlanI18nPreQuestions.displayName = "QuestionDayTripPlanI18nPreQuestions";
